var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3429 8.66103L2.00353 14.8135C1.12607 15.3351 0 14.7035 0 13.652V1.34706C0 0.297205 1.12444 -0.33604 2.00353 0.18722L12.3429 6.33969C12.5425 6.45655 12.7084 6.62546 12.8238 6.8293C12.9392 7.03314 13 7.26466 13 7.50036C13 7.73607 12.9392 7.96758 12.8238 8.17142C12.7084 8.37526 12.5425 8.54418 12.3429 8.66103Z",
    fill: "#00D015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayGreen);
export default __webpack_public_path__ + "static/media/playGreen.c22fc567544c3c0d37a1157f9dfaf1a8.svg";
export { ForwardRef as ReactComponent };